// extracted by mini-css-extract-plugin
module.exports =  {"Topic":"eCGU80GEDnxleaFO89Ov","Topic_Box_Shadow":"x6Zr8SupWBWSduWywrHr","EditTopic":"iITGtHhU_qX2OdindI_n","Topic_Tooltip":"IjPmu_cse_qtqludPp2Y"};